
import { computed, defineComponent, PropType } from 'vue'

import { PlanningRecordContainerInvoice } from '@/new-services/types/planning'

// @components
import ContainersCargoStatus from '@/modules/NewDispatcher/components/ContainersCargoStatus/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

import { formatDateWithTimeFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    props: {
        column: {
            type: Object as PropType<{ name: string; key: string }>,
            required: true,
        },
        row: {
            type: Object as PropType<PlanningRecordContainerInvoice>,
            required: true,
        },
    },
    components: { ContainersCargoStatus, Cheap },
    setup(props) {
        const getCheckOrTimesIcon = (is_check: number | boolean) => {
            return `fas ${is_check ? 'fa-check text-green-500' : 'fa-times'}`
        }

        const getShipmentIcon = (type_id: number) => {
            let class_str = 'fas '

            if (type_id === 1) {
                class_str += 'fa-car'
            } else {
                class_str += 'fa-plane'
            }

            return class_str
        }

        const getTimerClass = computed(() => {
            if (!props.row.timer) return

            if (props.row.timer[0] === '-') {
                return 'text-red-500'
            } else {
                return 'text-green-500'
            }
        })

        return { getCheckOrTimesIcon, getShipmentIcon, getTimerClass, formatDateWithTimeFromBackend }
    },
})
